import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  CONSENT_MANAGEMENT_CREATE_REQUEST,
  CONSENT_MANAGEMENT_CREATE_SUCCESS,
  CONSENT_MANAGEMENT_CREATE_FAILURE,
  CONSENT_MANAGEMENT_CREATE_RESET,
  CONSENT_MANAGEMENT_LIST_REQUEST,
  CONSENT_MANAGEMENT_LIST_SUCCESS,
  CONSENT_MANAGEMENT_LIST_FAILURE,
  CONSENT_MANAGEMENT_LIST_RESET,
  CONSENT_MANAGEMENT_GET_REQUEST,
  CONSENT_MANAGEMENT_GET_SUCCESS,
  CONSENT_MANAGEMENT_GET_FAILURE,
  CONSENT_MANAGEMENT_GET_RESET,
  CONSENT_MANAGEMENT_EDIT_REQUEST,
  CONSENT_MANAGEMENT_EDIT_SUCCESS,
  CONSENT_MANAGEMENT_EDIT_FAILURE,
  CONSENT_MANAGEMENT_EDIT_RESET,
  CONSENT_MANAGEMENT_DEACTIVATE_REQUEST,
  CONSENT_MANAGEMENT_DEACTIVATE_SUCCESS,
  CONSENT_MANAGEMENT_DEACTIVATE_FAILURE,
  CONSENT_MANAGEMENT_DEACTIVATE_RESET,
  CONSENT_MANAGEMENT_EXPORT_REQUEST,
  CONSENT_MANAGEMENT_EXPORT_SUCCESS,
  CONSENT_MANAGEMENT_EXPORT_FAILURE,
  CONSENT_MANAGEMENT_EXPORT_RESET,

} from './../../constants'
export function createConsent(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/consent`,
      method: 'POST',
      types: [
        CONSENT_MANAGEMENT_CREATE_REQUEST,
        CONSENT_MANAGEMENT_CREATE_SUCCESS,
        CONSENT_MANAGEMENT_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}
export function getConsentList(access_token) {
    return {
      [CALL_API]: {
        endpoint: `${BASE_URL}/consent`,
        method: 'GET',
        types: [
          CONSENT_MANAGEMENT_LIST_REQUEST,
          CONSENT_MANAGEMENT_LIST_SUCCESS,
          CONSENT_MANAGEMENT_LIST_FAILURE,
        ],
        headers: {
          'authorization': `bearer ${access_token}`,
        },
      },
    }
  }
  export function getConsentByID(id, access_token) {
    return {
      [CALL_API]: {
        endpoint: `${BASE_URL}/consent/${id}`,
        method: 'GET',
        types: [
          CONSENT_MANAGEMENT_GET_REQUEST,
          CONSENT_MANAGEMENT_GET_SUCCESS,
          CONSENT_MANAGEMENT_GET_FAILURE,
        ],
        headers: {
          'authorization': `bearer ${access_token}`,
        },
      },
    }
  }
  export function editConsent(id, payload, access_token) {
    return {
      [CALL_API]: {
        endpoint: `${BASE_URL}/consent/${id}`,
        method: 'PUT',
        types: [
          CONSENT_MANAGEMENT_EDIT_REQUEST,
          CONSENT_MANAGEMENT_EDIT_SUCCESS,
          CONSENT_MANAGEMENT_EDIT_FAILURE,
        ],
        headers: {
          'authorization': `bearer ${access_token}`,
        },
        body: JSON.stringify(payload),
      },
    }
  }
  export function deactivateCosent(id, access_token) {
    return {
      [CALL_API]: {
        endpoint: `${BASE_URL}/consent/${id}/delete`,
        method: 'PUT',
        types: [
          CONSENT_MANAGEMENT_DEACTIVATE_REQUEST,
          CONSENT_MANAGEMENT_DEACTIVATE_SUCCESS,
          CONSENT_MANAGEMENT_DEACTIVATE_FAILURE,
        ],
        headers: {
          'authorization': `bearer ${access_token}`,
        },
      },
    }
  }
  export function exportConsent(access_token) {
    return {
      [CALL_API]: {
        endpoint: `${BASE_URL}/consent/exports`,
        method: 'GET',
        types: [
          CONSENT_MANAGEMENT_EXPORT_REQUEST,
          CONSENT_MANAGEMENT_EXPORT_SUCCESS,
          CONSENT_MANAGEMENT_EXPORT_FAILURE,
        ],
        headers: {
          'authorization': `bearer ${access_token}`,
        },
      },
    }
  }
  export function resetDeactivateConsent() {
    return {
      type: CONSENT_MANAGEMENT_DEACTIVATE_RESET,
    }
  }
  export function resetListConsent() {
    return {
      type: CONSENT_MANAGEMENT_LIST_RESET,
    }
  }
  export function resetCreateConsent() {
    return {
      type: CONSENT_MANAGEMENT_CREATE_RESET,
    }
  }
  export function resetEditConsent() {
    return {
      type: CONSENT_MANAGEMENT_EDIT_RESET,
    }
  }
  export function resetGetConsent() {
    return {
      type: CONSENT_MANAGEMENT_GET_RESET,
    }
  }
  export function resetExportUser() {
    return {
      type: CONSENT_MANAGEMENT_EXPORT_RESET,
    }
  }
  


// WEBPACK FOOTER //
// ./src/actions/consent-management/consent-management-action.js